import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

export const roleGuard: CanActivateFn = async (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.profileLoaded()) {
    await auth.loadProfileOnInit();
  }

  const user = auth.currentUser();
  if (!user) {
    router.navigate(['/auth/login']);
    return false;
  }

  const requiredRoles = route.data?.['roles'] as string[];
  const userRoles = user.data.roles;

  if (!requiredRoles || requiredRoles.length === 0) return true;

  const ok = requiredRoles.some((r) => userRoles.includes(r));
  if (!ok) {
    router.navigate(['/auth/login']);
    return false;
  }

  return true;
};
